export default {
    INITIALIZE: 'TRADERA_SHOP/INITIALIZE',
    SET_IS_LOADING: 'TRADERA_SHOP/SET_IS_LOADING',
    SET_ITEM_DETAILS: 'TRADERA_SHOP/SET_ITEM_DETAILS',
    SET_PRODUCT: 'TRADERA_SHOP/SET_PRODUCT'
};
